import React from "react";
import AboutContent from "../AboutContent";
function About() {
  return (
    <>
      <AboutContent/>
    </>
  );
}

export default About;
